import QuillBlock from 'quill/blots/block';
import type { Parchment } from 'quill/core';

const getClosestLine = (blot: Parchment.LeafBlot | null) => {
  let current: Parchment.Blot | null = blot;
  while (current && !(current instanceof QuillBlock)) {
    current = current.parent;
  }
  return current;
};

export default getClosestLine;
